<template>
    <div class="vetri_new">

    <v-sheet class="mx-auto no-shadow montatura-vetro">

    <v-slide-group v-model="model2" :class="p4x" show-arrows>
      <v-slide-item
        v-for="list in vetri_elements"
        :key="list.COLOREVETRO"
      
      >
      <div class="wrapper_vetri_new test"     :class="numero_vetri"
         
     v-on:mouseover="mouseover(list.VETRO_LANG, vetro_name)"
    v-on:mouseleave="mouseleave(vetro_name)"
       @click="onCardClick_vetro(list.COLOREVETRO)" >
  
 <!--  <VueCustomTooltip :label="list.VETRO_LANG" position="is-bottom"> -->
          <img
                v-bind:src="list.IMG"
                :class="list.SELECTED ? 'active_image vetri_new ' : 'not_active_image_vetri_new vetri_new '"
              />  
         <!--       onerror =" this.src='/risorse/preview/IMGNOTFOUND.jpg'" -->
              <!--  </VueCustomTooltip>   -->
    <p    class="nome_sintentico montatura_testo_label pesante_scuro vetro_testo testo_finitura_vetro vetro_p_product"
              :class="list.SELECTED ? 'opaco_no '   : 'opaco_si ' "
              
         > {{ list.finiturastrutturatesto }} </p>

    <p :class="list.SELECTED ? 'mostra_paragrafo '   : 'non_mostrare_paragrafo '" > {{ list.VETRO_LANG }} </p>



     </div>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>

  <p class="vetro_name nome_del_vetro_dinamico"> {{ vetro_name }} </p>
    </div>
</template>
<script>
import checkLanguage from "../classes/class_check_language";

export default {
  name: "vetro_new",
  mounted() {
       let l = this.$store.state.products_store.VETROSET;
            if (l){
              this.onCardClick_vetro(l);
            }
  this.$store.subscribe((mutation) => {
             if (mutation.type == 'filter_glass'){
                       this.vetri_elements =  this.$store.state.product.vetri_new;
                                    if(typeof(   this.vetri_elements) !== 'undefined' ){
                                        if (this.vetri_elements.length == 1) {
                                          this.numero_vetri = 'un_solo_vetro';
                                        }else{
                                          this.numero_vetri = '';
                                        }
                                    }
                       try{
                       this.vetri_elements.forEach(vetro_element => {
                           if (vetro_element.SELECTED == true){
                               this.vetro_name = vetro_element.VETRO_LANG;
                           }            
                       });
                            } catch (error) {
            console.info(error);
        }
             }

             if (mutation.type == 'click_on_montatura_bis'){
               let l = this.$store.state.products_store.VETROSET;
              setTimeout(() => {
                this.onCardClick_vetro(l);

              }, 0);
             }

          // quando clicko su finiuta montatura
           if (mutation.type == 'click_on_montatura'){
              setTimeout(() => {
                try{
                this.vetri_elements.forEach(element => {
                  if (element.SELECTED == true){
                    let l = element.COLOREVETRO;
                      if(typeof(  this.$store.state.products_store.COLOREVETRO ) !== 'undefined' ){

                   if (this.$store.state.products_store.COLOREVETRO.length >1){
                     this.onCardClick_vetro(l);
                   }
                  }
                  }
                });
                     } catch (error) {
            console.info(error);
        }

              }, 0);
             }

             if (mutation.type == 'select_product_by_id'){
                    this.vetri_elements =  this.$store.state.product.vetri_new;
                      if(typeof(   this.vetri_elements) !== 'undefined' ){
                                        if (this.vetri_elements.length == 1) {
                                          this.numero_vetri = 'un_solo_vetro';
                                        }else{
                                          this.numero_vetri = '';
                                        }
                                    }
                        // foreach vetri_elements in this.vetri_elements
                        try{
                    this.vetri_elements.forEach(vetro_element => {
                        if (vetro_element.SELECTED == true){
                            this.vetro_name = vetro_element.VETRO_LANG;
                        }
                        
                      
                    });
                         } catch (error) {
            console.info(error);
        }
          }

  });

    let c = new  checkLanguage();
    this.is_italian = c.is_italian();
  },
  computed: {
  
       maxwidth (){
      try {
           let width = document.getElementById('dfnweio3').offsetWidth;

        return width;
      } catch (error) {
        let width = 800;
        return width;
      }
   
    },
  
     debug(){
      return this.$store.state.products.debug;
    },
          p4x(){
      try {
        let pixels = window.innerWidth;
        if (pixels>630){
          return ' pa-4-5 vetri_padding_left_zero';
        }else{
          return ' mobile ';
        }
      } catch (error) {
        
        return ' pa-4-5 vetri_padding_left_zero';
      }
    },
   
  },
  data: () => ({
    model2: [],
    vetri_elements: [],
    is_italian: true,
    vetro_name: '',
    changed : '',
    visualize : 'no_hover',
    numero_vetri : ''
  }),
  methods: {
  
    mouseover(value){

      this.visualize = this.vetro_name;
        this.vetro_name = value;
    },
      
    
    mouseleave(value){
      this.vetro_name = value;
      this.vetro_name = this.visualize;

    },
    onCardClick_vetro(COLOREVETRO) {
    this.$store.commit('click_on_vetro', COLOREVETRO);
 //   this.$store.commit("new_product_link_search");
    },
    remove_slash(string){
    
      if(string.length==3){
        string = string.replace("/", "");
        return string;
      }else{
        return string;
      }
    },

  }

  
};
</script>
<style>
.un_solo_vetro{
  pointer-events: none;
}
.non_mostrare_paragrafo{
  display: none;
}
.mostra_paragrafo{
      position: absolute;
    
        font-size: 10px;
            margin-top: -5px !important;
}
.nome_del_vetro_dinamico{
  display:none;
}
.wrapper_vetri_new {
  height:130px;
}
.vetri_padding_left_zero{
  min-width: 39vw;
}
img.vetri_new{
    max-width: 70px
}
div.wrapper_vetri_new{
    padding-left: 10px;
}
.not_active_image_vetri_new{
    opacity: 0.5;
}
.vetri_padding_left_zero{
    padding-left: 0px !important;
}
.vetri_padding_left_zero{
  padding-right:16px !important;
  padding-left: 0px !important;
  padding-bottom: 16px !important;
  padding-top: 16px !important;
}

</style>